// import axios from 'axios';

const state = {
  flagtitle: '',
  action: '',
  yymm_b: '',
  yymm_e: '',
  statType: '',
  Showtable: null,
  region: '',
  cc: '',
  rcode: '',
  tt: '',
  mm: '',
  topicID: '',
  filterID: '',
  titleText: '',
  infoFilter: '',
  selectType: 0,
  selectSubType: 0
}
// const getter = {

// }
const actions = {
  getVal: ({ commit, state }, getData) => {
    commit('SET_FLAGTITILE', getData.flagtitle)
    commit('SET_ACTION', getData.action)
    commit('SET_YYMM_B', getData.yymm_b)
    commit('SET_YYMM_E', getData.yymm_e)
    commit('SET_STATTYPE', getData.statType)
    commit('SET_REGION', getData.region)
    commit('SET_CC', getData.cc)
    commit('SET_RCODE', getData.rcode)
    commit('SET_TT', getData.tt)
    commit('SET_MM', getData.mm)
    commit('SET_TOPICID', getData.topicID)
    commit('SET_FILTERID', getData.filterID)
    commit('SET_TITLETEXT', getData.titleText)
    commit('SET_INFOFILTER', getData.infoFilter)

    commit('SET_SELECTTYPE', getData.selectType)
    commit('SET_SELECTSUBTYPE', getData.selectSubType)
  }

}

const mutations = {
  SET_FLAGTITILE (state, getData) {
    state.flagtitle = getData
  },
  SET_ACTION (state, getData) {
    state.action = getData
  },
  SET_YYMM_B (state, getData) {
    state.yymm_b = getData
  },
  SET_YYMM_E (state, getData) {
    state.yymm_e = getData
  },
  SET_STATTYPE (state, getData) {
    state.statType = getData
  },
  SET_REGION (state, getData) {
    state.region = getData
  },
  SET_CC (state, getData) {
    state.cc = getData
  },
  SET_RCODE (state, getData) {
    state.rcode = getData
  },
  SET_TT (state, getData) {
    state.tt = getData
  },
  SET_MM (state, getData) {
    state.mm = getData
  },
  SET_TOPICID (state, getData) {
    state.topicID = getData
  },
  SET_FILTERID (state, getData) {
    state.filterID = getData
  },
  SET_COINS (state, coins) {
    state.coins = coins
  },
  SET_TITLETEXT (state, getData) {
    state.titleText = getData
  },
  SET_INFOFILTER (state, getData) {
    state.infoFilter = getData
  },
  SET_SELECTTYPE (state, getData) {
    state.selectType = getData
  },
  SET_SELECTSUBTYPE (state, getData) {
    state.selectSubType = getData
  }

}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
